import { render } from "./JoinNowStep03DOB.vue?vue&type=template&id=a6584caa&scoped=true"
import script from "./JoinNowStep03DOB.vue?vue&type=script&lang=js"
export * from "./JoinNowStep03DOB.vue?vue&type=script&lang=js"

import "./JoinNowStep03DOB.vue?vue&type=style&index=0&id=a6584caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6584caa"]])

export default __exports__